export * from "./design-share"
export * from "./custom-spus"
export * from "./shop"
export * from "./miscellaneous"
export * from "./miscellaneous/index"
export * from "./order-info/index"
export * from "./shop/index"
export * from "./account-info/api/Auth"
export * from "./account-info/api/Invoice"
export * from "./shop/api/categories"
export * from "./account-info/api/interface/AuthInterface"
export * from "./account-info/api/interface/InvoiceInterface"
export * from "./account-info/index"
export * from "./shop/api/interface/categoriesInterface"
export * from "./order-management/index"
export * from "./financial"
export * from "./home/index"
export * from "./customer_service/CustomerPlugin"
export * from "./material/Material"
export * from "./comment/index"
export * from "./dss-order"

export function pxToRem(size = 34) {
  const scaleRatio = () => {
    const baseSize = size
    const scale = document.documentElement.clientWidth / 1920
    document.documentElement.style.fontSize = baseSize * Math.min(scale, 1) + "px"
  }
  // initialization fontSize
  scaleRatio()
  // reload set fontSize when page scale change
  window.onresize = function () {
    scaleRatio()
  }
}
